import { useState } from 'react';
import styles from './App.module.css';
import ButtonContainer from './components/ButtonContainer';
import Display from './components/Display';

function App() {

  let [calValue, setCalValue] = useState("");

  const onButtonClicked = (buttonText) => {
    console.log(buttonText);

    if (buttonText === 'C') {
      setCalValue(" ");
    } else if (buttonText === '=') {
      const result = eval(calValue); // evaluate where we pass the string for text view
      setCalValue(result);
    } else {
      let newDisplay = calValue + buttonText;
      setCalValue(newDisplay);
    }

  }



  return (
    <div className={styles.calculator}>
      <Display displayValue={calValue} />
      <ButtonContainer onButtonClick={onButtonClicked} />
    </div>
  );
}

export default App;
